import {
  ADD_MATERIAL,
  ADD_MATERIAL_FAILURE,
  ADD_MATERIAL_SUCCESS,
  FETCH_MATERIALS,
  FETCH_MATERIALS_SUCCESS,
  FETCH_MATERIALS_FAILURE,
  UPDATE_MATERIAL,
  UPDATE_MATERIAL_SUCCESS,
  UPDATE_MATERIAL_FAILURE,
  BULK_UPLOAD_MATERIALS,
  BULK_UPLOAD_MATERIALS_SUCCESS,
  BULK_UPLOAD_MATERIALS_FAILURE,
  SHARE_MATERIAL,
  SHARE_MATERIAL_SUCCESS,
  SHARE_MATERIAL_FAILURE,
} from './types';

const fetchMaterials = (payload) => ({
  type: FETCH_MATERIALS,
  ...payload,
});

const fetchMaterialsSuccess = (payload) => ({
  type: FETCH_MATERIALS_SUCCESS,
  ...payload,
});

const fetchMaterialsFailure = () => ({
  type: FETCH_MATERIALS_FAILURE,
});

const addMaterial = (payload) => ({
  type: ADD_MATERIAL,
  ...payload,
});

const addMaterialSuccess = (payload) => ({
  type: ADD_MATERIAL_SUCCESS,
  ...payload,
});

const addMaterialFailure = () => ({
  type: ADD_MATERIAL_FAILURE,
});

const updateMaterial = (payload) => ({
  type: UPDATE_MATERIAL,
  ...payload,
});

const updateMaterialSuccess = (payload) => ({
  type: UPDATE_MATERIAL_SUCCESS,
  ...payload,
});

const updateMaterialFailure = () => ({
  type: UPDATE_MATERIAL_FAILURE,
});

const bulkUploadMaterials = (payload) => ({
  type: BULK_UPLOAD_MATERIALS,
  ...payload,
});

const bulkUploadMaterialsSuccess = (payload) => ({
  type: BULK_UPLOAD_MATERIALS_SUCCESS,
  ...payload,
});

const bulkUploadMaterialsFailure = () => ({
  type: BULK_UPLOAD_MATERIALS_FAILURE,
});

const shareMaterial = (payload) => ({
  type: SHARE_MATERIAL,
  ...payload,
});

const shareMaterialSuccess = (payload) => ({
  type: SHARE_MATERIAL_SUCCESS,
  ...payload,
});

const shareMaterialFailure = () => ({
  type: SHARE_MATERIAL_FAILURE,
});

export {
  fetchMaterials,
  fetchMaterialsSuccess,
  fetchMaterialsFailure,
  addMaterial,
  addMaterialSuccess,
  addMaterialFailure,
  updateMaterial,
  updateMaterialSuccess,
  updateMaterialFailure,
  bulkUploadMaterials,
  bulkUploadMaterialsSuccess,
  bulkUploadMaterialsFailure,
  shareMaterial,
  shareMaterialSuccess,
  shareMaterialFailure,
};

